import { BaseService, RequestOptions } from 'src/app/services/base.service';
import { Injectable, inject } from '@angular/core';
import { PostData } from '../pages/home/models/post-data.model';
import { Observable } from 'rxjs';
import { convertObjectToFormData } from '../helpers/convertToFormData';

@Injectable({
	providedIn: 'root'
})
export class PostsService {

	private static readonly REQUEST_TOP_PATH: string = "posts";

	private _baseService: BaseService = inject(BaseService);

	public getPostData(id: number, requestOptions?: RequestOptions): Observable<PostData> {
		const requestEndpoint: string = "GetPost";

		let url = `${PostsService.REQUEST_TOP_PATH}/${requestEndpoint}?id=${id}`;

		return this._baseService.get(
			url,
			requestOptions
		);
	}

	public getLatestPosts(lastPostId: number, quantity: number, requestOptions?: RequestOptions): Observable<PostData[]> {
		const requestEndpoint: string = "GetLatestPosts";

		let url = `${PostsService.REQUEST_TOP_PATH}/${requestEndpoint}?lastPostId=${lastPostId}&quantity=${quantity}`;

		return this._baseService.get(
			url,
			requestOptions
		);
	}

	public upsertPost(postData: PostData, requestOptions?: RequestOptions): Observable<{success: boolean, message: string}> {
		const requestEndpoint: string = "UpsertPost";

		let url = `${PostsService.REQUEST_TOP_PATH}/${requestEndpoint}`;

		const formData = new FormData();

		convertObjectToFormData(formData, postData);

		return this._baseService.postFormData(
			url,
			formData,
			requestOptions
		);
	}

	public deletePost(id: number, requestOptions?: RequestOptions): Observable<{success: boolean, message: string}> {
		const requestEndpoint: string = "DeletePost";

		let url = `${PostsService.REQUEST_TOP_PATH}/${requestEndpoint}?id=${id}`;

		return this._baseService.postFormData(
			url,
			undefined,
			requestOptions
		);
	}
}
